/* eslint-disable quotes */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  en: [
    {
      title: 'Which is the best option when working with chemical structures?',
      details: {
        type: 'option',
        correctAnswer: 'Water',
        options: ['Water', 'Carbon', 'Gas'],
      },
    },
    {
      title: 'What is the most common isotope of hydrogen?',
      details: {
        type: 'option',
        correctAnswer: 'Protium',
        options: ['Protium', 'Deuterium', 'Tritum', 'Hydrogen only has one isotope!'],
      },
    },
    {
      title: 'How would you best describe the colour of fire inside a vacuum?',
      details: {
        type: 'text',
      },
    },
    {
      title:
        'One of the essential minerals in the human body is salt. How much salt (NaCl) is in the average adult human body?',
      details: {
        type: 'option',
        correctAnswer: '250 grams',
        options: ['1 kilogram', '250 grams', '500 grams', 'practically none'],
      },
    },
    {
      title: "You can't live without water! What is its chemical formula?",
      details: {
        type: 'option',
        correctAnswer: 'H2O',
        options: ['O2', 'H2O', 'H2', 'H2O2'],
      },
    },
    {
      title: 'Who is credited with the invention of the modern periodic table?',
      details: {
        type: 'option',
        correctAnswer: 'Nobel',
        options: ['Mendeleev', 'Lavoisier', 'Mendel', 'Nobel'],
      },
    },
    {
      title: 'Which of these elements is a nonmetal?',
      details: {
        type: 'option',
        correctAnswer: 'Sulfur',
        options: ['Beryllium', 'Aluminum', 'Manganese', 'Sulfur'],
      },
    },
    {
      title: 'Which country consumes the most chocolate per capita?',
      details: {
        type: 'text',
      },
    },
    {
      title: "You can't live without iron. Where in the body is most of the iron located?",
      details: {
        type: 'option',
        correctAnswer: 'Your blood',
        options: ['Your skin', 'Your blood', 'Your brain', 'Your bones'],
      },
    },
    {
      title: 'If you fill a glass to the brim with ice water and the ice melts, what will happen?',
      details: {
        type: 'option',
        correctAnswer: 'The water level will drop slightly as the ice melts.',
        options: [
          'The glass will over flow as the ice turns to water.',
          'The level of water in the glass will remain unchanged as the ice melts.',
          'The water level will drop slightly as the ice melts.',
          "I'll never find out because I'll drink the water or walk away before anything happens.",
        ],
      },
    },
  ],
  de: [
    {
      title: 'Welches ist die beste Option, wenn Sie mit chemischen Strukturen arbeiten?',
      details: {
        type: 'option',
        correctAnswer: 'Wasser',
        options: ['Wasser', 'Kohlenstoff', 'Gas'],
      },
    },
    {
      title: 'Was ist das häufigste Isotop von Wasserstoff?',
      details: {
        type: 'option',
        correctAnswer: 'Protium',
        options: ['Protium', 'Deuterium', 'Tritum', 'Wasserstoff hat nur ein Isotop!'],
      },
    },
    {
      title: 'Wie würden Sie die Farbe des Feuers in einem Vakuum am besten beschreiben?',
      details: {
        type: 'text',
      },
    },
    {
      title:
        'Einer der essentiellen Mineralien im menschlichen Körper ist Salz. Wie viel Salz (NaCl) enthält der durchschnittliche erwachsene menschliche Körper?',
      details: {
        type: 'option',
        correctAnswer: '250 Gramm',
        options: ['1 Kilogramm', '250 Gramm', '500 Gramm', 'praktisch keine'],
      },
    },
    {
      title: 'Ohne Wasser kann man nicht leben! Wie lautet seine chemische Formel?',
      details: {
        type: 'option',
        correctAnswer: 'H2O',
        options: ['O2', 'H2O', 'H2', 'H2O2'],
      },
    },
    {
      title: 'Wem wird die Erfindung des modernen Periodensystems zugeschrieben?',
      details: {
        type: 'option',
        correctAnswer: 'Nobel',
        options: ['Mendeleev', 'Lavoisier', 'Mendel', 'Nobel'],
      },
    },
    {
      title: 'Welches dieser Elemente ist ein Nichtmetall?',
      details: {
        type: 'option',
        correctAnswer: 'Sulfur',
        options: ['das Beryllium', 'Aluminium', 'das Mangan', 'der Schwefel'],
      },
    },
    {
      title: 'Welches Land verbraucht am meisten Schokolade pro Kopf?',
      details: {
        type: 'text',
      },
    },
    {
      title: 'Ohne Eisen kann man nicht leben. Wo im Körper befindet sich das meiste Eisen?',
      details: {
        type: 'option',
        correctAnswer: 'Dein Blut',
        options: ['Deine Haut', 'Dein Blut', 'Dein Gehirn', 'Deine Knochen'],
      },
    },
    {
      title:
        'Wenn Sie ein Glas bis zum Rand mit Eiswasser füllen und das Eis schmilzt, was passiert dann?',
      details: {
        type: 'option',
        correctAnswer: 'Der Wasserstand sinkt leicht, wenn das Eis schmilzt.',
        options: [
          'Das Glas läuft über, wenn das Eis zu Wasser wird.',
          'Der Wasserstand im Glas bleibt beim Schmelzen des Eises unverändert.',
          'Der Wasserstand sinkt leicht, wenn das Eis schmilzt.',
          'Ich werde es nie herausfinden, weil ich das Wasser trinke oder weggehe, bevor etwas passiert.',
        ],
      },
    },
  ],
};
